import React from "react";
import DataError from "./Errors";

const SubmissionNotices = (props) => {
  const renderWarnings = () => {
    if (props.displayColumnMappingWarning) {
      return (
        <div className="notify__error notify__error--warning animated fadeInUp  mb--16">
          <div className="notify__error__col">
            <div className="notify__error__error-title notify__error__error-title--warning">
              Warning
            </div>
          </div>

          <div className="notify__error__col notify__error__col--spread">
            <div className="notify__error__description-title">Confirm Column Mappings</div>
            <div className="notify__error__description">
              Please ignore if you have confirmed that your mappings names are correct
            </div>
          </div>
        </div>
      );
    }
  };

  const renderNotice = () => {
    if (props.displayNotice) {
      if (!props.filteredDataRows > 0) {
        return renderMessageNothingToSubmit();
      } else {
        return <DataError errors={props.descriptions} />;
      }
    }
  };

  const renderMessageNothingToSubmit = () => {
    return (
      <div className="notify__banner">
        <div className="notify__banner__icon">
          <i className="solid solid-budicon-notification"> </i>
        </div>
        <div className="notify__banner__notice__title">
          <strong>Nothing to submit -</strong>
        </div>
        <div className="notify__banner__notice">
          It looks like there are no matching NDCs in this file.
        </div>
      </div>
    );
  };

  return (
    <div>
      {renderWarnings()}
      {renderNotice()}
    </div>
  );
};

export default SubmissionNotices;
